<template lang="">
  <div class="ai-record-page">
    <ai-record></ai-record>
  </div>
</template>
<script>
import aiRecord from "./aiRecord.vue";
export default {
  components: {
    aiRecord,
  },
}
</script>
<style lang="scss" scoped>
  .ai-record-page {
    height: 100vh;
    overflow-y: scroll;
    width: 100%;
  }
</style>